const cle = (evaluationId: string) => `fluence-passation-prenom:${evaluationId}`;

export function memoriserPrenomPassation(evaluationId: string, prenom: string) {
  try {
    window.sessionStorage.setItem(cle(evaluationId), prenom);
  } catch {
    return;
  }
}

export function lirePrenomPassation(evaluationId: string) {
  if (!evaluationId) return '';
  try {
    return window.sessionStorage.getItem(cle(evaluationId)) ?? '';
  } catch {
    return '';
  }
}
